import { cn } from '~/lib/utils'
import { ClientOnly } from 'remix-utils/client-only'
import { CarouselContent, CarouselItem } from '~/components/UI/shadcn/carousel'

import CarouselContainer from '../../helpers/CarouselContainer'
import TimelineCard, { TimelineCardProps } from '../TimelineCard/TimelineCard'

const TimelineCarousel = ({ content, layoutColour }: CarouselProps) => {
  const { backgroundColour, cards, autoplay, controlsColour } = content

  const foregroundColour =
    layoutColour === 'ink-blue' || layoutColour === 'mid-blue'
      ? 'white'
      : 'ink-blue'

  const images = cards?.some(
    (c: TimelineCardProps['content']) => c?.image !== null
  )

  return (
    <ClientOnly>
      {() => (
        <div>
          {cards && (
            <CarouselContainer
              className='space-y-m'
              options={{ autoplay, align: 'start' }}
              controlsColour={
                controlsColour === layoutColour
                  ? foregroundColour
                  : controlsColour
              }
              hideControls={cards.length < 2 ? true : false}
              controlsClasses='lg:ml-m sm:ml-s ml-xs-plus'
            >
              <CarouselContent className='ml-0'>
                {cards.map((item, index: Index) => (
                  <CarouselItem
                    key={index}
                    className={cn(
                      'max-h-[495px] max-w-[275px] !pl-0 sm:max-h-[520px] lg:max-h-[575px]',
                      item.featured
                        ? 'lg:max-w-[620px] lg:basis-2/3!'
                        : 'lg:max-w-[310px]'
                    )}
                  >
                    <TimelineCard
                      content={{ ...item, backgroundColour }}
                      images={images}
                      layoutColour={layoutColour}
                    />
                  </CarouselItem>
                ))}
              </CarouselContent>
            </CarouselContainer>
          )}
        </div>
      )}
    </ClientOnly>
  )
}

export default TimelineCarousel
